module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-vehicle-controller"
  }, [_c('statistics-card5', [_c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('span', [_vm._v("Odometer")]), _c('h3', [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]), _c('div', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('span', [_vm._v("Fuel Level:")]), _c('h3', [_vm._v(_vm._s(_vm.item.fuel_level) + "%"), (_vm.item.range !== null) ? _c('span', [_vm._v("(" + _vm._s(_vm.item.range) + _vm._s(_vm.configuration.locale.locale_distance_unit.value) + ")")]) : _vm._e()])]), _c('div', {
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('span', [_vm._v("Door Status:")]), _c('h3', [_vm._v(_vm._s(_vm.item.door_status))])]), _c('div', {
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('span', [_vm._v("Engine Status:")]), _c('h3', [_vm._v(_vm._s(_vm.item.engine_status))])]), _c('div', {
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_c('span', [_vm._v("Parking Lot")]), (_vm.item.parking_lot.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'parkingLot',
        params: {
          id: _vm.item.parking_lot.id
        }
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : _c('h3', [_vm._v("--")])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('router-tab-headers', {
    attrs: {
      "id": "vehicle-details",
      "tabs": _vm.tabs
    }
  }, [_c('router-view', {
    staticClass: "content",
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-216dba77!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Vehicle.vue
// module id = 2320
// module chunks = 1